import React from 'react'

const Buoy = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/buoy',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g strokeWidth='1.2' fill='none' fillRule='evenodd'>
      <path
        d='M4 16l3.696-3.696m4.687-4.687L16 4M16 16l-3.696-3.696M7.617 7.617L4 4'
        stroke={secondaryColor}
        strokeLinejoin='round'
      />
      <path
        d='M10 19c-4.966 0-9-4.034-9-9s4.034-9 9-9 9 4.034 9 9-4.034 9-9 9z'
        stroke={primaryColor}
      />
      <path
        d='M10 13.273A3.275 3.275 0 0 1 6.727 10 3.275 3.275 0 0 1 10 6.727 3.275 3.275 0 0 1 13.273 10 3.275 3.275 0 0 1 10 13.273z'
        stroke={primaryColor}
      />
    </g>
  </svg>
)

export default Buoy
